import * as React from 'react';
import { getPrintedAddressForBudget, budgetTimeSummaryText, getBudgetTypeSummary, getBudgetActiveDatesSummary, } from './budget_helper';
import ModalFormWarning from './modal_form_warning';
import { Text, Icon, Stack } from '@doordash/design-language';
import { BudgetSummary, InfoLine, IconContainer, IconText, } from './delete_flex_budget_modal_content_styles';
var generateBudgetSummary = function (budget) {
    var printedAddress = getPrintedAddressForBudget(budget);
    var spendingLimitExtraText = budget.maximumAllotment && budget.maximumAllotment.displayString
        ? " \u2014 " + budget.maximumAllotment.displayString
        : '';
    var flexSummary = getBudgetTypeSummary(budget) + ", " + getBudgetActiveDatesSummary(budget);
    var timeSummary = budgetTimeSummaryText(budget.availabilitiesList);
    return (React.createElement(BudgetSummary, null,
        React.createElement(Stack, { size: Stack.Sizes.Large },
            React.createElement(Text, { color: Text.Colors.TextPrimary, children: "" + budget.name + spendingLimitExtraText, styles: Text.Styles.Bold18 }),
            React.createElement(Text, { color: Text.Colors.TextTertiary, children: flexSummary })),
        React.createElement(InfoLine, null,
            React.createElement(IconContainer, null,
                React.createElement(Icon, { type: Icon.Types.TimeLine })),
            React.createElement(IconText, null, timeSummary)),
        React.createElement(InfoLine, null,
            React.createElement(IconContainer, null,
                React.createElement(Icon, { type: Icon.Types.LocationPinEnabledLine })),
            React.createElement(IconText, null, printedAddress))));
};
export var DeleteFlexBudgetModalContent = function (_a) {
    var budget = _a.budget, errorMessage = _a.errorMessage;
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalFormWarning, { title: 'Budget will be deleted permanently', description: "\n          Employees will not be able to use this budget once you confirm.\n          Active or already scheduled orders will not be impacted.\n        " }),
        generateBudgetSummary(budget),
        errorMessage && (React.createElement(Stack, { size: Stack.Sizes.Small },
            React.createElement(Text, { color: Text.Colors.TextError, children: errorMessage, textAlign: Text.TextAlignments.Center })))));
};
export default DeleteFlexBudgetModalContent;
